import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useCallback } from 'react';

import { ErrorResponse } from '../api/hscan';
import {
  authorizeTwoFactorLogin,
  requestTwoFactorLogin,
  requestMaskedPhone,
  AuthenticationCodeAuthorize,
  MaskedPhoneNumberResponse,
} from '../api/hscan/twoFactorAuth';

import { MutationOption, QueryOption } from './react-query-type';

export const useMaskedPhone = (
  options?: QueryOption<
    MaskedPhoneNumberResponse,
    MaskedPhoneNumberResponse,
    AxiosError<ErrorResponse>
  >,
) => {
  const fetch = useCallback(async () => {
    const { data } = await requestMaskedPhone();
    return data;
  }, []);

  return useQuery({
    queryKey: ['requestTwoFactorLoginPhone'],
    queryFn: fetch,
    ...options,
  });
};

export const useRequestTwoFactorLogin = (
  options?: MutationOption<void, void, AxiosError<ErrorResponse>>,
) => {
  return useMutation({
    mutationFn: async () => {
      await requestTwoFactorLogin();
    },
    ...options,
  });
};

export const useAuthenticateTwoFactorLogin = (
  options?: MutationOption<
    AuthenticationCodeAuthorize,
    void,
    AxiosError<ErrorResponse>
  >,
) => {
  return useMutation({
    mutationFn: async (request: AuthenticationCodeAuthorize) => {
      await authorizeTwoFactorLogin(request);
    },
    ...options,
  });
};
